import classNames from 'classnames';
import * as React from 'react';
import { Href } from 'redux-little-router';

import { makeGridPopupContainer } from '../../containers/GridPopup/GridPopup';
import { Bem } from '../../service/Bem/Bem';
import { TestBem } from '../../service/TestBem';
import { groups } from '../../typings/common';
import {
    GridRecommendationsData,
    RecommendationKey,
    RecommendationType
} from '../../typings/recommendations';
import { GridCellContentOverflow } from '../GridCellContentOverflow/GridCellContentOverflow';
import { RecommendationCardView } from '../RecommendationCard/RecommendationCard';
import {
    RecommendationsTooltip,
    RecommendationsTooltipProps
} from '../RecommendationsTooltip/RecommendationsTooltip';
import { RouteStyledLink } from '../StyledLink/StyledLink';

import './GridGroupNameCell.css';

export interface GridGroupNameCellProps {
    name: string;
    id: string;
    groupUrl?: Href;
    recommendations?: {
        items: GridRecommendationsData;
        onOpenRecommendationsPopup?: () => void;
        onSubmitRecommendation?: (
            id: string,
            type: RecommendationType,
            keys: Array<RecommendationKey>,
            itemName: string
        ) => void;
        onShowRecommendation?: (
            view: RecommendationCardView,
            type: RecommendationType
        ) => void;
    };
    isCompactViewEnabled: boolean;
}

const GridPopupContainer = makeGridPopupContainer<RecommendationsTooltipProps>(
    RecommendationsTooltip
);

const BLOCK = 'grid-group-name-cell';

export class GridGroupNameCell extends React.PureComponent<
    GridGroupNameCellProps
> {
    render() {
        const { id, isCompactViewEnabled } = this.props;

        return (
            <div
                className={Bem.cls({
                    block: BLOCK,
                    mods: { compact: isCompactViewEnabled }
                })}
            >
                <h3 className={Bem.cls(BLOCK, 'title')}>
                    {this.renderGridCellContentOverflow()}
                    {this.renderRecomendations()}
                </h3>
                <div
                    className={classNames(
                        Bem.cls(BLOCK, 'cid'),
                        TestBem.cls(BLOCK, 'cid')
                    )}
                >
                    № {id}
                </div>
            </div>
        );
    }

    private renderGridCellContentOverflow() {
        const { recommendations } = this.props;

        if (!recommendations) {
            return this.getGroupNameContent();
        }

        return (
            <GridCellContentOverflow>
                {this.getGroupNameContent()}
            </GridCellContentOverflow>
        );
    }

    private renderRecomendations() {
        const { recommendations } = this.props;

        if (!recommendations) {
            return null;
        }

        return (
            <GridPopupContainer
                cls={Bem.cls(BLOCK, 'recommendations')}
                view={groups}
                recommendations={recommendations.items.data}
                recommendationIconType={
                    recommendations.items.recommendationsIconType
                }
                onShowRecommendation={recommendations.onShowRecommendation}
                onSubmitRecommendation={this.onSubmitRecommendation}
                onPopupOpen={recommendations.onOpenRecommendationsPopup}
            />
        );
    }

    private getGroupNameContent = () => {
        const { groupUrl, name } = this.props;

        if (groupUrl) {
            return (
                <RouteStyledLink
                    href={groupUrl}
                    title={name}
                    cls={Bem.cls(BLOCK, 'group-link')}
                >
                    {name}
                </RouteStyledLink>
            );
        }

        return name;
    };

    private onSubmitRecommendation = (
        type: RecommendationType,
        keys: Array<RecommendationKey>
    ) => {
        const { recommendations, name } = this.props;

        if (recommendations && recommendations.onSubmitRecommendation) {
            recommendations.onSubmitRecommendation(
                this.props.id,
                type,
                keys,
                name
            );
        }
    };
}
